export default {"src":"/_next/static/image/public/images/ic_in_person.aff84cb925db10bc58757ca802e0a459.svg","height":15,"width":16};